const hostImageUrl = 'https://rescloud.ediblearrangements.com/image/upload/';
const creativeMarketingPath = 'Creative-Marketing/site_support';

export const noImageAvailable = `${hostImageUrl}${creativeMarketingPath}/assets/NoImageAvailable.webp`;
export const headerEdibleLogo = `${hostImageUrl}${creativeMarketingPath}/assets/EA_NEW-VIS-ID_primary-logo_Horiz_200x60.webp`;
export const doorDashLogo = `${hostImageUrl}v1714436092/${creativeMarketingPath}/DoorDash_Logo.webp`;
export const uberEatsLogo = `${hostImageUrl}v1714436199/${creativeMarketingPath}/UberEats_Logo.webp`;
export const microsoftLogo = `${hostImageUrl}v1714438326/${creativeMarketingPath}/Microsoft_logo.webp`;
export const animatedLogo = `${hostImageUrl}/v1706285150/${creativeMarketingPath}/animated-basket_trans.webp`;
